var loaders = require('../layout/components/loaders');
var Report = require('../../../../models/reports/report');

var loadPromise = null;

function loadReportRegistry() {
  if (loadPromise) return loadPromise;
  loadPromise = loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/report/types',
    method: 'GET',
    background: true
  })
  .then(function (result) {
    if (result) {
      Report.applyRegistryPayload(result);
    }
    return result;
  })
  .finally(function () {
    loadPromise = null;
  });
  return loadPromise;
}

module.exports = loadReportRegistry;
